import { Box, Button, Stack, Typography } from '@mui/material';
import { useDialog } from 'common/hooks/useDialog';
import { AuthContext } from 'common/providers/AuthContextProvider/AuthContextProvider';
import { useAddAccount } from 'components/accounts/AddAccountDialog/useAddAccount';
import { ContactWidget } from 'components/ContactWidget/ContactWidget';
import { Banner } from 'components/HomePage/Banner/Banner';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import ConnectAccountsImageLarge from '../../../assets/images/connect-account-banner.svg';
import { homeTheme } from '../../../themes/homeTheme';
import {
  DataProtectionGuaranteesDialog,
  DataProtectionGuaranteesDialogProps,
} from '../../accounts/DataProtectionGuarantees/DataProtectionGuaranteesDialog';
import { styles } from './AddAccountBanner.styles';

export const AddAccountBanner: React.FC = () => {
  const { t } = useTranslation();
  const { isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();

  const addAccount = useAddAccount();

  const handleAddAccount = async () => {
    if (await dataProtectionDialog.create({})) {
      // workaround: as this banner is also shown to unregistered client, we don't want to use
      // addAccount directly for them but redirect to login instead
      isAuthenticated ? addAccount() : navigate('/login?select-bank=open');
    }
  };

  const dataProtectionDialog = useDialog<DataProtectionGuaranteesDialogProps, boolean>(DataProtectionGuaranteesDialog, {
    instanceId: 'data-protection-dialog',
  });

  const handleDataProtectionClick = () => {
    dataProtectionDialog.create({});
  };

  return (
    <Stack spacing={8}>
      <Stack alignItems="center" mx={2} spacing={3} textAlign="center">
        <Typography component="div" sx={styles.headline}>
          {t('homepage.accounts.addAccountBanner.header.title')}
        </Typography>
        <Typography textAlign={'center'} variant="bodyStrongL">
          {t('homepage.accounts.addAccountBanner.header.subtitle')}
          <Box onClick={handleDataProtectionClick}>
            <Typography color={homeTheme.palette.primary.dark} sx={styles.link} variant="bodyStrongL">
              {t('homepage.accounts.addAccountBanner.dataProtection')}
            </Typography>
          </Box>
        </Typography>
        <Button onClick={handleAddAccount} size="large" sx={{ mb: 4 }}>
          {t('homepage.accounts.addAccountBanner.connectButton')}
        </Button>
      </Stack>
      <Banner
        alignItems="center"
        imageSrc={ConnectAccountsImageLarge}
        text={t('homepage.accounts.addAccountBanner.text')}
        title={t('homepage.accounts.addAccountBanner.title')}
      />
      <ContactWidget />
    </Stack>
  );
};
